// src/services/authService.js
import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_SERVER;

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token; // Retorna true se o token existir
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const logout = () => {
  localStorage.removeItem("token");
};

// Exemplo de requisição autenticada usando o token JWT
export const getProtectedData = async () => {
  const token = getToken();
  const config = {
    headers: {
      Authorization: `Bearer ${token}` // Inclui o token no cabeçalho da requisição
    }
  };

  try {
    const response = await axios.get(`${SERVER_URL}/protected-route`, config);
    return response.data;
  } catch (error) {
    console.error("Error fetching protected data", error);
  }
};
